export default __webpack_public_path__ + "static/media/BoPay.1681d164.svg";